import createReducer from 'utils/redux/createReducer'

const initialState = {
	property: 'All'
	, category: 'All'
}

export default createReducer(initialState, {
	REPAIRMEN_FILTER_UPDATED: (currentState, action) => (
		{
			property: (action.data.property)? action.data.property : currentState.property
		  , category: (action.data.category)? action.data.category : currentState.category
		}
	)
  , CLEAR_REPAIRMEN_FILTERS: () => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/repairmenFilters.js